import { Action } from '@reduxjs/toolkit';
import merge from 'lodash/merge';

import { DeepPartial } from 'types/util';

import { SrpFilterName, SrpFiltersState, SrpFilterValue } from 'types/srpFilters';

export enum SrpActionType {
  SetFilters = 'srpFilters/setFilters',
}

export interface SetSrpFiltersAction {
  type: SrpActionType.SetFilters;
  payload: DeepPartial<SrpFiltersState>;
}

export const setSrpFilters = (filters: DeepPartial<SrpFiltersState>): SetSrpFiltersAction => {
  return {
    type: SrpActionType.SetFilters,
    payload: filters,
  };
};

export const srpFiltersInitialState: SrpFiltersState = {
  [SrpFilterName.Year]: {
    min: 1940,
    max: new Date().getFullYear() + 1,
  },
  [SrpFilterName.Condition]: {
    new: false,
    cpo: false,
    used: false,
  },
  [SrpFilterName.Cylinders]: {
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    8: false,
    10: false,
    12: false,
  },
  [SrpFilterName.Make]: undefined,
  [SrpFilterName.Model]: undefined,
  [SrpFilterName.Radius]: { number: 50 },
  [SrpFilterName.SortBy]: undefined,
  [SrpFilterName.Price]: {
    hideNoPriceListings: false,
  },
};

export const srpFiltersReducer = (
  state: SrpFiltersState = srpFiltersInitialState,
  action: Action
): SrpFiltersState => {
  if (!Object.values(SrpActionType).includes(action.type)) {
    return state;
  }

  if (action.type === SrpActionType.SetFilters) {
    const setFiltersAction = action as SetSrpFiltersAction;
    return merge({}, state, setFiltersAction.payload);
  }

  return state;
};

export const getSrpFilter = <T extends SrpFilterValue>(
  state: SrpFiltersState,
  name: SrpFilterName
): T => {
  return state[name] as T;
};
